import script from "./CarsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CarsPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__